import React from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

const safePath = (path: string | null) => path?.startsWith('/') && !path.startsWith('//') ? path : '/my-diagrams'

export const AuthCallbackPage: React.FC = () => {
  const { user, loading } = useAuth()
  const [params] = useSearchParams()
  if (loading) return <div className="flex min-h-screen items-center justify-center text-gray-600">Completing sign in…</div>
  if (!user) return <Navigate to="/" replace state={{ authError: 'Authentication could not be completed.' }} />
  return <Navigate to={safePath(params.get('returnTo'))} replace />
}
